import {Children} from "react";
import PropTypes from "prop-types";

import {greyishBlue100, greyishBlue50, sidebarColor} from "assets/jss/main";

import {UserAgentUtils} from "utils/useragent";

WmsMobileLayout.propTypes = {
    children: PropTypes.node,
    disableMargin: PropTypes.bool, // temp prop. Remove when we don't use WmsMobileLayout on desktop views
}

const headerHeight = '64px';
const footerHeight = '80px';

function WmsMobileLayout({children, disableMargin = false}) {
    const LeftHeaderPart = findSlotOfType(children, LeftHeader);
    const RightHeaderPart = findSlotOfType(children, RightHeader);
    const FooterPart = findSlotOfType(children, Footer);
    const ContentPart = findSlotOfType(children, Content);


    return(
        <div style={{
            width: '100%',
            height: '100vh',
            backgroundColor: greyishBlue50,
            display: 'flex',
            flexDirection: 'column',
            ...!UserAgentUtils.isMobile() && !disableMargin && { // MobileLayout is still use on desktop, we must do this for the sidebar
                marginLeft: '240px'
            }
        }}>
            {(LeftHeaderPart || RightHeaderPart) && (
                <header className="wms-mobile-header" style={{
                    backgroundColor: sidebarColor,
                    width: '100%',
                    height: headerHeight,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '0 8px',
                    borderBottom: '1px solid '+greyishBlue100,
                    flexShrink: 0
                }}>
                    {LeftHeaderPart}
                    {RightHeaderPart}
                </header>
            )}
            <section style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                flex: 1,
                overflowY: 'auto',
            }}>
                {ContentPart}
            </section>
            {FooterPart && (
                <footer style={{
                    width: '100%',
                    height: footerHeight,
                    backgroundColor: sidebarColor,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '0 16px',
                    flexShrink: 0
            }}>
                {FooterPart}
            </footer>)}
        </div>
    )

}

function findSlotOfType(children, slotType) {
    return Children.toArray(children).find((child) => child.type === slotType);
}

function LeftHeader ({children}) {
    return (
        <div>
            {children}
        </div>
    )
}

function RightHeader ({children}) {
    return (
        <div>
            {children}
        </div>
    )
}

function Content ({children, overflow = 'scroll'}) {
    return (
        <div style={{overflow: overflow}}>
            {children}
        </div>
    )
}

function Footer ({children}) {
    return (
        <>
            {children}
        </>
    )
}

export default Object.assign(WmsMobileLayout, { LeftHeader, RightHeader, Content, Footer });
